import { QuestRoutine } from "@joonapp/web-shared"
import { MutableRefObject } from "react"
import { create } from "zustand"

import { UserSelectFilterType } from "../../types"

interface QuestBoardStore {
  questBoardRef: MutableRefObject<any> | null
  setQuestBoardRef: (questBoardRef: MutableRefObject<any> | null) => void

  selectedUserId: number | null
  setSelectedUserId: (selectedUserId: number | null) => void

  selectedFilterType: UserSelectFilterType
  setSelectedFilterType: (selectedFilterType: UserSelectFilterType) => void

  selectedRoutine: QuestRoutine | null
  setSelectedRoutine: (selectedRoutine: QuestRoutine | null) => void

  showWelcome: boolean
  setShowWelcome: (showWelcome: boolean) => void
}

const useQuestBoardStore = create<QuestBoardStore>((set) => ({
  setQuestBoardRef: (questBoardRef: MutableRefObject<any> | null) =>
    set({ questBoardRef }),
  questBoardRef: null,

  selectedUserId: null,
  setSelectedUserId: (selectedUserId: number | null) => {
    if (selectedUserId) set({ selectedFilterType: UserSelectFilterType.USER })
    set({ selectedUserId })
  },

  selectedFilterType: UserSelectFilterType.ALL_USERS,
  setSelectedFilterType: (selectedFilterType: UserSelectFilterType) => {
    if (selectedFilterType !== UserSelectFilterType.USER)
      set({ selectedUserId: null })
    set({ selectedFilterType })
  },

  selectedRoutine: null,
  setSelectedRoutine: (selectedRoutine: QuestRoutine | null) =>
    set({ selectedRoutine }),

  showWelcome: false,
  setShowWelcome: (showWelcome: boolean) => set({ showWelcome }),
}))

export default useQuestBoardStore
